import { createLifecycleFor } from "actions/account/collections";
import { TYPE } from "reducers/account/versionedFlows";

export const {
  callApi: getVersionedFlow,
  patterns,
  replace
} = createLifecycleFor(TYPE);
